<template>
  <div class="calico-loan-profile-page">
    <div class="calico-loan-profile-container">
      <CalicoLoanProfile
        :amount="1000000"
        type="SBA 7(a)"
        use="Working Capital / Cash Flow"
        personal-credit-score="Excellent (720+)"
        @edit="onEdit"
        @complete="onComplete"
      />
    </div>
  </div>
</template>

<script>
import CalicoLoanProfile from '@/components/pattern/loanProfile/index.vue'

export default {
  name: 'LoanProfilePage',
  components: {
    CalicoLoanProfile,
  },
  methods: {
    onEdit() {
      console.log('edit clicked')
    },
    onComplete() {
      console.log('complete clicked')
    },
  },
}
</script>

<style scoped lang="scss">
.calico-loan-profile-page {
  @include inline-space($space-none);
  justify-content: center;
  align-items: center;

  .calico-loan-profile-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 400px;
  }
}
</style>